module.exports = __webpack_public_path__ + "img/gcp.09643848.svg";